import { render } from "./UpdateBankDetailsDialog.vue?vue&type=template&id=287c2686&scoped=true"
import script from "./UpdateBankDetailsDialog.vue?vue&type=script&lang=js"
export * from "./UpdateBankDetailsDialog.vue?vue&type=script&lang=js"

import "./UpdateBankDetailsDialog.vue?vue&type=style&index=0&id=287c2686&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287c2686"]])

export default __exports__